export default __webpack_public_path__ + "static/abmg-footer-logo-with-icon-arctic-blue-f788a14bff662fb01e678b7d57a01aec.svg";